import React from "react";

interface Props {
  min: number;
  max: number;
}

export const SliderGradations = ({ min, max }: Props) => {
  const ticks = getTickPositions(min, max);

  return (
    <>
      <div className="tick-container">
        {ticks.map((tick, index) =>
          index === 0 || index === ticks.length - 1 ? null : (
            <div
              key={tick}
              className="slider-tick"
              style={{ left: `${tick}%` }}
            />
          )
        )}
      </div>
    </>
  );
};

const getTickPositions = (min: number, max: number): number[] => {
  const range = max - min;
  let numGradations = Math.round(range / 10);
  numGradations = Math.max(6, Math.min(numGradations, 15));

  const gradationInterval = range / (numGradations - 1);

  const ticks: number[] = [];
  for (let i = 0; i < numGradations; i++) {
    const value = min + i * gradationInterval;
    const percentage = ((value - min) / range) * 100;
    ticks.push(percentage);
  }

  return ticks;
};
